"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const audiences = [{
  title: "Electrical Contractors",
  description: "Evermark engraves legend plates, panel nameplates, and panel schedules on a contractor's timeline, with rush options when an inspection is close.",
  linkText: "Contractor solutions",
  linkUrl: "/industries/electrical-contractors/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/audience_contractors.png"
}, {
  title: "Specifying Engineers",
  description: "Evermark supplies submittal packages and basis-of-design language so engineers can specify Evermark Industrial Solutions by name.",
  linkText: "Compliance & submittals",
  linkUrl: "/Industries",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/audience_engineers.png"
}, {
  title: "Facility & MRO Engineers",
  description: "Evermark produces durable arc flash labels, valve tags, and equipment identification in materials matched to wash-down, heat, and outdoor exposure.",
  linkText: "Facility labeling",
  linkUrl: "/industries/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/audience_facility.png"
}];
export default function WhoTheseServicesAreFor() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="who-these-services-are-for" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerReveal.ref} className={`mx-auto max-w-3xl text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Who Uses Evermark's Engraving Services?
          </h2>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-700 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {audiences.map((audience, index) => <div data-index={index} key={index} className="flex h-full">
              <Card className="flex flex-col h-full w-full border-border/50 bg-card hover:border-primary/50 transition-colors duration-300 shadow-sm hover:shadow-md">
                <CardHeader className="space-y-4">
                  <div className="size-12 flex items-center justify-center rounded-lg bg-secondary border border-primary/30 overflow-hidden">
                    <img src={audience.image} data-wvc-srcset={`${audience.image}-wvc-srcset`} data-wvc-sizes={`${audience.image}-wvc-sizes`} alt={audience.title} className="size-8 object-contain" loading="lazy" />
                  </div>
                  <CardTitle className="font-default text-xl text-card-foreground">
                    {audience.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-muted-foreground leading-relaxed">
                    {audience.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-4 pb-6">
                  <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 font-medium group">
                    <Link to={audience.linkUrl}>
                      {audience.linkText}
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}